// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__k532n","list":"menu_list__eitZB","link":"menu_link__gT5KI","list-item":"menu_list-item__bD3FR","icon":"menu_icon__4NLbX"};